const emptyCardStyle = () => ({
	card: {
		textAlign: 'center',
		padding: '60px 0',
	},
	buttonsWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		margin: '0 auto',
		maxWidth: 300,
	},
	descriptionWrapper: {
		maxWidth: 386,
		margin: '16px auto 35px',
	},
	image: {
		paddingBottom: 40,
	},
});

export default emptyCardStyle;
